import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const AttachIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Attach",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M20.66 11.97a1.52 1.52 0 1 0-2.16-2.14l-7.49 7.49c-.57.65-.92 1.5-.92 2.44 0 2.04 1.66 3.7 3.7 3.7.93 0 1.77-.34 2.42-.9s10.82-10.82 10.82-10.82a5.88 5.88 0 0 0 1.42-3.84 5.898 5.898 0 0 0-9.75-4.47S5.91 16.21 5.91 16.21a8.05 8.05 0 0 0-2.36 5.71c0 4.47 3.62 8.09 8.09 8.09 2.24 0 4.26-.91 5.72-2.38l9.47-9.47a1.52 1.52 0 0 0-2.15-2.15l-9.47 9.46c-.92.94-2.2 1.53-3.61 1.53-2.78 0-5.04-2.25-5.04-5.04 0-1.42.59-2.7 1.53-3.61S20.88 5.56 20.88 5.56a2.83 2.83 0 0 1 2.07-.89c1.58 0 2.85 1.28 2.85 2.85 0 .81-.34 1.55-.88 2.06S14.1 20.4 14.1 20.4a.702.702 0 0 1-.99-.99l7.55-7.47Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M10.066 28.146a7.72 7.72 0 0 1-5.497-2.275c-1.509-1.52-2.275-3.428-2.275-5.497s.812-4.034 2.275-5.497l7.817-7.817a1.14 1.14 0 0 1 1.611 0 1.14 1.14 0 0 1 0 1.611L6.18 16.49c-1.04 1.04-1.611 2.422-1.611 3.885S5.14 23.22 6.18 24.26c2.137 2.137 5.623 2.137 7.772 0l12.514-12.514a3.283 3.283 0 0 0 0-4.64 3.283 3.283 0 0 0-4.64 0L9.312 19.62a1.076 1.076 0 0 0 0 1.509c.4.4 1.108.4 1.508 0l7.817-7.818a1.138 1.138 0 1 1 1.611 1.611l-7.816 7.818c-1.27 1.269-3.475 1.269-4.743 0a3.366 3.366 0 0 1 0-4.743L20.203 5.483c2.171-2.172 5.703-2.172 7.874 0s2.172 5.703 0 7.874L15.563 25.871a7.74 7.74 0 0 1-5.497 2.275"
      })
    })
  }));
};